if (!Shopify.designMode) {
  gsap.registerPlugin(ScrollTrigger);

  // Animate [intro-anim-blur] elements
  document.querySelectorAll('[intro-anim-blur]').forEach((blurEl) => {
    const delayAttr = blurEl.getAttribute('intro-anim-delay');
    const delay = delayAttr && !isNaN(delayAttr) ? parseFloat(delayAttr) : 0;

    gsap.set(blurEl, { y: '3rem', filter: 'blur(10px)', opacity: 0 });

    gsap.to(blurEl, {
      y: '0rem',
      filter: 'blur(0px)',
      opacity: 1,
      duration: 0.8,
      delay: delay,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: blurEl,
        start: 'top 90%',
        toggleActions: 'play none none none',
      },
    });
  });

  // Animate [intro-anim-image-blur] elements
  document.querySelectorAll('[intro-anim-image-blur], .intro-anim-image-blur').forEach((blurEl) => {
    const delayAttr = blurEl.getAttribute('intro-anim-delay');
    const delay = delayAttr && !isNaN(delayAttr) ? parseFloat(delayAttr) : 0;

    gsap.set(blurEl, { filter: 'blur(5px)' });

    gsap.to(blurEl, {
      filter: 'blur(0px)',
      duration: 0.8,
      delay: delay,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: blurEl,
        start: 'top 90%',
        toggleActions: 'play none none none',
      },
    });
  });

  // Animate [intro-anim-fade] elements
  document.querySelectorAll('[intro-anim-fade]').forEach((fadeEl) => {
    const delayAttr = fadeEl.getAttribute('intro-anim-delay');
    const delay = delayAttr && !isNaN(delayAttr) ? parseFloat(delayAttr) : 0;

    gsap.set(fadeEl, { y: '3rem', opacity: 0 });

    gsap.to(fadeEl, {
      y: '0rem',
      opacity: 1,
      duration: 1.2,
      delay: delay,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: fadeEl,
        start: 'top 90%',
        toggleActions: 'play none none none',
      },
    });
  });
}
